import React, { FC, ReactNode, useState } from 'react';
import { IRequest, InventoryStockContext } from './context';
import { StockType } from 'models/stock.model';
const InventoryStockProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const selectedRequests: IRequest[] = [];
  const [requests, setRequests] = useState<IRequest[]>(selectedRequests);
  const [isPreview, setIsPreview] = useState(false);
  const [scrollIndex, setScrollIndex] = useState<number | null>(null);
  const [stocksToEdit, setStocksToEdit] = useState<StockType[]>([]);
  const [stockToRecordWastage, setStockToRecordWastage] = useState<StockType | null>(null);
  const vendorsArray = [
    {
      name: 'Femite food ltd',
      price: 'N 1,700/gram',
      id: '1'
    },
    {
      name: 'Femite food',
      price: 'N 1,500/gram',
      id: '2'
    },
    {
      name: 'Femite',
      price: 'N 1,200/gram',
      id: '3'
    }
  ];
  return (
    <InventoryStockContext.Provider
      value={{
        requests,
        setRequests,
        isPreview,
        setIsPreview,
        selectedRequests,
        vendorsArray,
        scrollIndex,
        setScrollIndex,
        stocksToEdit,
        setStocksToEdit,
        stockToRecordWastage,
        setStockToRecordWastage
      }}>
      {children}
    </InventoryStockContext.Provider>
  );
};

export default InventoryStockProvider;
